import { SettingsBase } from './SettingsBase';

export class ContestantListJsonSettings extends SettingsBase {
    static NAME_OF_CLASS = 'ContestantListJsonSettings';
    public AutoUpdateLastSeen: boolean = true;

    public constructor(args?: { AutoUpdateLastSeen: boolean }) {
        super();
        this.AutoUpdateLastSeen = args?.AutoUpdateLastSeen ?? true;
    }

    public static Create({ AutoUpdateLastSeen = true }) {
        return new ContestantListJsonSettings({
            AutoUpdateLastSeen,
        });
    }
}
